import script from "./AboutIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./AboutIcon.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__